import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { LOG_APPENDER_CONFIG_OPTIONS, LoggerConfigOptions, OtelLogAppenderService } from './otel-log-appender.service';

export function provideLogging(config?: LoggerConfigOptions): EnvironmentProviders {
    return makeEnvironmentProviders([
        OtelLogAppenderService,
        { provide: LOG_APPENDER_CONFIG_OPTIONS, useValue: config },
        provideEnvironmentInitializer(() => inject(OtelLogAppenderService).start())
    ]);
}
